import { Route } from 'src/routes/Route'

export const NotificationsRoute = Route({ path: '/notifications' })
export type NotificationsRoute = Route<typeof NotificationsRoute>
